/**
 * 供应商详情页面
 * 重构后: Tab components 已拆分到 components/ 目录
 */
import React, { useState, useEffect } from 'react';
import { Card, Tabs, Spin, message } from 'antd';
import { useParams, useNavigate } from 'react-router-dom';
import { ArrowLeftOutlined } from '@ant-design/icons';
import supplyChainService from '../../../services/supplyChainService';

// 拆分后的Tab组件
import BasicInfoTab from './components/BasicInfoTab';
import FinancialTab from './components/FinancialTab';
import SKUTab from './components/SKUTab';
import PerformanceTab from './components/PerformanceTab';

const SupplierDetail: React.FC = () => {
    const { id } = useParams<{ id: string }>();
    const navigate = useNavigate();
    const [supplier, setSupplier] = useState<any>(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetchSupplierDetail();
    }, [id]);

    const fetchSupplierDetail = async () => {
        setLoading(true);
        try {
            // Use retrieve API to get full financial stats
            const res = await supplyChainService.getSupplierById(parseInt(id!));
            setSupplier(res.data);
        } catch (error) {
            message.error('加载供应商信息失败');
        } finally {
            setLoading(false);
        }
    };


    if (loading) {
        return (
            <div style={{ textAlign: 'center', padding: '100px 0' }}>
                <Spin size="large" />
            </div>
        );
    }

    if (!supplier) {
        return null;
    }

    const tabItems = [
        { key: 'basic', label: '基本信息', children: <BasicInfoTab supplier={supplier} /> },
        { key: 'financial', label: '财务分析', children: <FinancialTab supplier={supplier} /> },
        { key: 'sku', label: 'SKU分布', children: <SKUTab supplier={supplier} /> },
        { key: 'performance', label: '绩效指标', children: <PerformanceTab supplier={supplier} /> }
    ];

    return (
        <div style={{ padding: 24 }}>
            <div style={{ marginBottom: 16 }}>
                <a onClick={() => navigate('/supply-chain/procurement/suppliers')} style={{ cursor: 'pointer' }}>
                    <ArrowLeftOutlined /> 返回供应商列表
                </a>
            </div>

            <Card title={<h2 style={{ margin: 0 }}>{supplier.name} - 详细信息</h2>}>
                <Tabs items={tabItems} />
            </Card>
        </div>
    );
};

export default SupplierDetail;
